import React from 'react'

import { StyledQuestion, Leaf } from './styles'
import leaf from './../../../img/heading-leaf.png'

const Question = ({ children }) => (
  <StyledQuestion>
    <Leaf src={leaf} animate={{ opacity: 1 }} transition={{ delay: 1 }} />
    {children}
  </StyledQuestion>
)

export default Question
